import { CONFIG } from '../../config'
import { MOMENT_TIME } from '../../momenttime'
import { UTILS } from '../../utils';
import { CONST_DISCUSS_MSG_TYPE } from '../base/consts';
import { FORMAT } from '../core/format';
import { PAIPAN } from '../core/paipan';
var DISCUSS_DATA_MANAGER = {
    /**
     * 获取新建论盘的名称
     * @returns '微信论盘_20191205'
     */
    getNewLunPanTitle() {
        // var startStr = detailInfo.f_name.length > 5 ? detailInfo.f_name.slice(0, 5) : detailInfo.f_name;
        var startStr = '';
        if(CONFIG.platform == 'qq') { startStr = 'QQ论盘_' };
        if(CONFIG.platform == 'wechat') { startStr = '微信论盘_' };
        var date = MOMENT_TIME.getFormateTimeYMDHmByTimeStamp();
        date = date.replace(/-/gi, '');
        date = date.replace(/:/gi, '');
        date = date.replace(/\s+/g, '');
        return startStr + date;
    },

    /**
     * 根据服务器返回的论盘数据获得前端展示的论盘数据结构体
     * @param {服务器返回论盘数据} data 
     */
    getLunPanDataByData(data) {
        var lunpanData = {
            id: data.id,
            hid: data.hid,
            rid: data.rid,
            edit: data.edit,
            isEnd: data.isEnd,
            title: data.f_title,
            shareCode: data.share,
            time: data.f_time,
            timeText: UTILS.getTimeInfoByTimeString(data.f_uptime)
        }
        return lunpanData;
    },

    /**
     * 根据修改数据的参数更新原始论盘列表数据
     * @param {原始数据} origiList 
     * @param {修改后的数据包含id和修改的内容} newData 
     */
    updateLunPanListDataTitle(origiList, newData) {
        origiList.forEach(data => {
            if(data.id == newData.id) {
                data.title = newData.f_title;
            }
        });
        return origiList;
    },

    /**
     * 根据删除数据的id删除本地数据
     * @param {原始数据} origiList 
     * @param {删除数据的id} deleteId 
     */
    deleteLunPanListData(origiList, deleteId) {
        origiList.forEach((data, index) => {
            if(data.id == deleteId) {
                origiList.splice(index, 1);
            }
        });
        return origiList;
    },

    /**
     * 根据服务器返回聊天数据获取前端聊天数据结构体
     * @param {服务器返回数据} data 
     * @param {服务器返回所有user数据} userData 
     * @param {引用的数据} quoteData 
     * {"type":"say","msg_type":1,"content":"234657987","time":1575851457,"userInfo":{"uid":"101238","nickname":"科达"},"id":"289110"}
     */
    getHistoryListDataByData(data, userData, quoteData) {
        var resultData = {}, content = '';
        //根据数据类型:1文本消息, 2图片, 3语音, 4带有@消息, 5八字, 6撤回, 7回复, 8点赞
        switch(data.msg_type) {
            case CONST_DISCUSS_MSG_TYPE.text:
                content = data.content;
                break;
            case CONST_DISCUSS_MSG_TYPE.image:
                break;
            case CONST_DISCUSS_MSG_TYPE.voice:
                break;
            case CONST_DISCUSS_MSG_TYPE.at:
                content = DISCUSS_DATA_MANAGER.replaceAtText(data.content, userData);
                break;
            case CONST_DISCUSS_MSG_TYPE.birth:
                content = '[你收到一条八字信息，请在app内打开查看]';
                break;
            case CONST_DISCUSS_MSG_TYPE.recall:
                content = '撤回了一条消息';
                break;
            case CONST_DISCUSS_MSG_TYPE.reply:
                var tempCont = data.content != '' ? JSON.parse(data.content) : {};
                content = tempCont && tempCont.r ? tempCont.r : '';
                break;
            case CONST_DISCUSS_MSG_TYPE.like:
                content = '';
                break;
            default:
                break;
        }
        resultData = {
            type: data.msg_type,
            id: data.id,
            content: content,
            time: data.time,
            uid: data.userInfo.uid,
            nickname: data.userInfo.nickname,
            isdel: CONST_DISCUSS_MSG_TYPE.recall ? true : false,
            likeNum: data.likes,
            avatarUrl: UTILS.getAvatarUrlByUid(data.userInfo.uid),
            donate: parseInt(data.userInfo.donate),
            vip: parseInt(data.userInfo.vip)
        }
        if(data.msg_type == CONST_DISCUSS_MSG_TYPE.reply && quoteData.id) {
            resultData = Object.assign({
                quoteCont: quoteData.nickname+'：'+quoteData.content
            }, resultData);
        }
        if(data.msg_type == CONST_DISCUSS_MSG_TYPE.like && quoteData.id) {
            resultData = Object.assign({
                quoteCont: quoteData.nickname+'：'+quoteData.content,
                quoteName: quoteData.nickname
            }, resultData);
        }
        return resultData;
    },
    
    /**
     * 根据前端返回到我的聊天数据获取前端聊天数据结构体
     * @param {服务器返回数据} data 
     * @param {引用的数据} quoteData 
     * {uid: this.curUserUid, msg_type:1, content:"234657987"}
     */
    getHistoryListDataByMyData(data, quoteData) {
        var resultData = {}, content = '',
            curTime = MOMENT_TIME.getTimeStampByNow(),
            avatarUrl = data.uid ? UTILS.getAvatarUrlByUid(data.uid) : '';
        //根据数据类型:1文本消息, 2图片, 3语音, 4带有@消息, 5八字, 6撤回, 7回复, 8点赞
        switch(data.msg_type) {
            case CONST_DISCUSS_MSG_TYPE.text:
            case CONST_DISCUSS_MSG_TYPE.at:
                content = data.content;
                break;
            case CONST_DISCUSS_MSG_TYPE.image:
                break;
            case CONST_DISCUSS_MSG_TYPE.voice:
                break;
            case CONST_DISCUSS_MSG_TYPE.birth:
                content = '[你收到一条八字信息，请在app内打开查看]';
                break;
            case CONST_DISCUSS_MSG_TYPE.recall:
                content = '你撤回了一条消息';
                break;
            case CONST_DISCUSS_MSG_TYPE.reply:
                var tempCont = data.content != '' ? JSON.parse(data.content) : {};
                content = tempCont && tempCont.r ? tempCont.r : '';
                break;
            case CONST_DISCUSS_MSG_TYPE.like:
                content = '我赞了"'+quoteData.nickname+'"'
                break;
            default:
                break;
        }
        resultData = {
            type: data.msg_type,
            content: content,
            time: curTime,
            uid: data.uid,
            id: -1,
            nickname: '',
            avatarUrl: avatarUrl,
        }
        // 追加回复引用的内容和点赞引用的内容
        if(data.msg_type == CONST_DISCUSS_MSG_TYPE.reply && quoteData.id) {
            resultData = Object.assign({
                quoteCont: quoteData.nickname+'：'+quoteData.content
            }, resultData);
        }
        if(data.msg_type == CONST_DISCUSS_MSG_TYPE.like && quoteData.id) {
            resultData = Object.assign({
                quoteCont: quoteData.nickname+'：'+quoteData.content,
                quoteName: quoteData.nickname
            }, resultData);
        }
        return resultData;
    },

    /**
     * 根据服务器返回聊天列表数据获取前端聊天数据结构体
     * @param {服务器返回列表数据}} data 
     * @param {服务器返回所有user数据} userData 
     * @param {引用的数据} quoteData 
     */
    getHistoryListDataByListData(data, userData, quoteData) {
        var resultData = {}, content = '',
            avatarUrl = data.userInfo.uid ? UTILS.getAvatarUrlByUid(data.userInfo.uid) : '';
        var tempCont = {};
        //根据数据类型:1文本消息, 2图片, 3语音, 4带有@消息, 5八字, 6撤回, 7回复, 8点赞
        switch(data.f_type) {
            case CONST_DISCUSS_MSG_TYPE.text:
                content = data.content;
                break;
            case CONST_DISCUSS_MSG_TYPE.image:
                content = '';
                break;
            case CONST_DISCUSS_MSG_TYPE.voice:
                content = '';
                break;
            case CONST_DISCUSS_MSG_TYPE.at:
                content = DISCUSS_DATA_MANAGER.replaceAtText(data.content, userData);
                break;
            case CONST_DISCUSS_MSG_TYPE.birth:
                content = '[你收到一条八字信息，请在app内打开查看]';
                break;
            case CONST_DISCUSS_MSG_TYPE.recall:
                content = '撤回了一条消息';
                break;
            case CONST_DISCUSS_MSG_TYPE.reply:
                tempCont = data.content != '' ? JSON.parse(data.content) : {};
                content = tempCont && tempCont.r ? tempCont.r : '';
                break;
            case CONST_DISCUSS_MSG_TYPE.like:
                content = '';
                break;
            default:
                break;
        }
        resultData = {
            type: data.f_type,
            id: data.id,
            content: content,
            isdel: data.isdel == 1 ? true : false,
            likeNum: data.likes,
            time: data.f_time,
            uid: data.userInfo.uid,
            nickname: data.userInfo.nickname,
            avatarUrl: avatarUrl,
            donate: parseInt(data.userInfo.donate),
            vip: parseInt(data.userInfo.vip)
        }
        // 再次处理引用的内容
        var newCont = quoteData && quoteData.content ? quoteData.content : '';
        if(newCont.indexOf('@') != -1) {
            newCont = DISCUSS_DATA_MANAGER.replaceAtText(newCont, userData);
        }else if(newCont.indexOf('{') != -1 && newCont.indexOf('}') != -1 && typeof(JSON.parse(newCont)) == 'object') {
            var newObj = JSON.parse(newCont);
            newCont = newObj.r ? newObj.r : newCont;
        }
        // 再次处理引用回复的数据
        if(data.f_type == CONST_DISCUSS_MSG_TYPE.reply && quoteData) {
            resultData = Object.assign({
                quoteCont: quoteData.userInfo.nickname+'：'+newCont
            }, resultData);
        }
        if(data.f_type == CONST_DISCUSS_MSG_TYPE.like && quoteData) {
            resultData = Object.assign({
                quoteCont: quoteData.userInfo.nickname+'：'+newCont,
                quoteName: quoteData.userInfo.nickname
            }, resultData)
        }
        return resultData;
    },

    /**
     * 获取'@'文本内的id数组
     * @param {'@'的文本内容} text 
     */
    getAtIdArray(text) {
        var textArr = text.split(' '), idArr = [];
        _.forEach(textArr, tt=>{
            tt = tt.indexOf('@') != -1 ? tt.replace('@', '') : tt;
            if(!isNaN(parseInt(tt))) {
                idArr.push(parseInt(tt));
            }
        });
        return idArr;
    },

    /**
     * 将'@id'转换为'@nickname'
     * @param {文本内容} text 
     * @param {用户信息} userInfo 
     */
    replaceAtText(text, userInfo) {
        var idArr = DISCUSS_DATA_MANAGER.getAtIdArray(text);
        _.forEach(idArr, id=> {
            var iid = '@'+id;
            var name = userInfo[id] ? '@'+userInfo[id].nickname : '';
            text = text.indexOf(iid) != -1 ? text.replace(iid, name) : text;
        })
        return text;
    },

    /**
     * 根据服务器返回列表数据获取客户端聊天记录列表数据
     * @param {原始列表数据} origiList 
     * @param {服务器返回列表数据} list 
     * @param {服务器返回所有user数据} userData 
     */
    initHistoryListDataByList(origiList, list, userData) {
        var me = this, resultList = [], newestId = 0;
        // console.error('initHistoryListDataByList------', origiList, list)
        list.forEach((data, index) => {
            var tempCont = {}, quoteData = {};
            tempCont = data.f_type == CONST_DISCUSS_MSG_TYPE.reply && data.content != '' ? JSON.parse(data.content) : {};
            quoteData = tempCont.id ? _.find(list, oData=>{return oData.id == tempCont.id}) : quoteData;
            quoteData = data.f_type == CONST_DISCUSS_MSG_TYPE.like ? _.find(list, oData=>{return oData.id == data.content}) : quoteData;
            var newData = me.getHistoryListDataByListData(data, userData, quoteData);
            var haveI = _.findIndex(origiList, ['id', newData.id]);
            if(haveI == -1) {
                resultList.push(newData);
            }
            newestId = (index == list.length - 1) ? data.id : newestId;
        });
        var myI = _.findIndex(origiList, ['id', -1]);
        if(myI != -1) {
            origiList.splice(myI, 1);
        }
        origiList = origiList.concat(resultList);
        origiList.sort((a, b) => {return a.time - b.time});
        return {
            resultList: origiList,
            newestId: newestId
        };
    },

    /**
     * 根据WS接收到的数据来更新当前聊天记录列表数据
     * @param {原始列表数据} origiList 
     * @param {新接收到的数据} newData 
     * @param {服务器返回所有user数据} userData 
     */
    addHistoryListDataByData(origiList, newData, userData) {
        var tempCont = {}, quoteData = {}, addData = {};
        // 处理回复数据引用的数据
        tempCont = newData.msg_type == CONST_DISCUSS_MSG_TYPE.reply && newData.content != '' ? JSON.parse(newData.content) : {};
        quoteData = tempCont.id ? _.find(origiList, data=>{return data.id == tempCont.id}) : quoteData;
        // 处理点赞数据引用的数据
        quoteData = newData.msg_type == CONST_DISCUSS_MSG_TYPE.like ? _.find(origiList, data=>{return data.id == newData.content}) : quoteData;
        addData = this.getHistoryListDataByData(newData, userData, quoteData);
        // console.log('addHistoryListDataByData-----', origiList, addData, newData)
        // 如果是删除消息的话，就要删除那条消息；
        if(newData.msg_type == CONST_DISCUSS_MSG_TYPE.recall) {
            var delIndex = _.findIndex(origiList, data=>{return data.id == newData.id});
            origiList.splice(delIndex, 1);
        }
        origiList.push(addData);
        origiList.sort((a, b) => {return a.time - b.time});
        return origiList;
    },

    /**
     * 根据我发送的数据类型:前端数据:来更新当前聊天记录列表数据
     * @param {原始列表数据} origiList 
     * @param {发送我的消息数据} myData 
     */
    addHistoryListDataByMyData(origiList, myData) {
        var tempCont = {}, quoteData = {}, addData = {};
        // 处理回复数据引用的数据
        tempCont = myData.msg_type == CONST_DISCUSS_MSG_TYPE.reply && myData.content != '' ? JSON.parse(myData.content) : {};
        quoteData = tempCont.id ? _.find(origiList, data=>{return data.id == tempCont.id}) : quoteData;
        // 处理点赞数据引用的数据
        quoteData = myData.msg_type == CONST_DISCUSS_MSG_TYPE.like ? _.find(origiList, data=>{return data.id == myData.content}) : quoteData;
        addData = this.getHistoryListDataByMyData(myData, quoteData);
        // console.log('addHistoryListDataByData-----', origiList, addData, myData)
        origiList.push(addData);
        origiList.sort((a, b) => {return a.time - b.time});
        return origiList;
    },

    /**
     * 根据服务器传回的数据获取论盘房间所有成员的列表信息
     * @param {服务器数据} data 
     * @param {我的uid} myUid 
     * @param {当前选中的数据} selectedArr 
     */
    getLunPanAllUserObjectByData(data, myUid, selectedArr) {
        var resultData = {};
        // console.error('getLunPanAllUserObjectByData======', selectedArr)
        _.forIn(data, userData => {
            if(userData.uid != myUid) {
                var selectedItem = _.find(selectedArr, sData=>{ return userData.uid == sData.uid});
                var firstL = UTILS.getFirstLetterByName(userData.nickname);
                resultData[firstL] = resultData[firstL] ? resultData[firstL] : [];
                resultData[firstL].push(Object.assign({
                    selected: selectedItem ? selectedItem.selected : false,
                    firstL: firstL
                }, userData));
            }
        });
        return resultData;
    },
    /**
     * 切换'@'列表数据的选中状态
     * @param {原始数据} origiData 
     * @param {当前操作元素数据} itemData 
     */
    updateLunPanAllUserObject(origiData, itemData) {
        _.forEach(origiData[itemData.firstL], userData => {
            if(userData.uid == itemData.uid) {
                userData.selected = !itemData.selected;
            }
        })
        return origiData;
    },
    /**
     * 获取主页论盘列表数据
     * @param {服务器返回数据} array 
     * @param {服务器返回用户信息} userInfo 
     */
    getLunPanMainListDataByData(array, userInfo) {
        var resultData = [];
        _.forEach(array, data => {
            var baziData = PAIPAN.GetInfo(data.bz.sex, data.bz.real_time ? data.bz.real_time : data.bz.birthday, data.bz.zwzs);
            var eightWordArr = FORMAT.getDiscussEightWordArrByData(data.bz.unknown, baziData);
            var userData = userInfo && userInfo[data.uid] ? userInfo[data.uid] : {};
            var newData = {
                id: data.id,
                rid: data.rid,
                hid: data.hid,
                bz: data.bz,
                share: data.share,
                bzSexColor: data.bz.sex == 0 ? 'man' : 'woman',
                bzSexText: data.bz.sex == 0 ? '乾' : '坤',
                title: data.f_title,
                timeStr: UTILS.getTimeInfoByTimeString(data.f_uptime),
                msgNum: data.msg_num,
                eightWordArr: eightWordArr,
                uid: data.uid,
                authorName: userData.nickname,
                authorUrl: userData.avatar
            };
            resultData.push(newData);
        });
        return resultData;
    }

}

export {
    DISCUSS_DATA_MANAGER
}